export default __webpack_public_path__ + "static/media/main-logo-text.e8875f69.png";